var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 4a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17m1.678 5.538a1.496 1.496 0 0 0-1.457 1.836 4.25 4.25 0 0 1-3.083-1.562 1.494 1.494 0 0 0 .463 1.997 1.5 1.5 0 0 1-.678-.188v.019c0 .725.516 1.33 1.2 1.467a1.5 1.5 0 0 1-.676.025c.19.594.743 1.027 1.398 1.039a3 3 0 0 1-2.215.62 4.23 4.23 0 0 0 2.293.671c2.751 0 4.256-2.279 4.256-4.255q0-.098-.005-.194c.293-.21.546-.474.747-.774q-.404.18-.86.236c.31-.186.546-.479.658-.828-.29.172-.609.296-.95.363a1.5 1.5 0 0 0-1.091-.472"
  })));
};
export default SvgTwitter;